import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { WalletForm } from './wallet-form';
import { WalletInfo } from './wallet-info';

// Banned collectors still need to configure their wallet to receive
// the final payout, so they're explicitly allowed on this page even
// though every other route bounces them to /banned.
const ALLOWED = new Set(['healthy', 'banned']);

export function WalletConfigPage(): ReactNode {
  const user = useAuthStore((s) => s.user);
  const nav = useNavigate();

  useEffect(() => {
    if (user && !ALLOWED.has(user.account_status)) {
      nav('/creators', { replace: true });
    }
  }, [user, nav]);

  if (!user || !ALLOWED.has(user.account_status)) return null;

  return (
    <div className="mx-auto max-w-[32rem] space-y-xl">
      <div>
        <h1 className="text-xl font-bold text-text-primary">
          Conecta tu wallet para recibir pagos
        </h1>
        <p className="mt-1 text-sm text-text-tertiary">
          Necesitamos tu billetera de USDC en la red de Ethereum para poder
          enviarte los pagos.
        </p>
      </div>
      <WalletForm current={user.usdc_wallet ?? ''} />
      <WalletInfo />
    </div>
  );
}
